export const DEFAULT_API_HANDLER_CONFIG = {
  delayBetweenRequests: 100,
  maxConcurrentRequests: 3,
  enableToastNotifications: true,
  cacheTTL: 5 * 60 * 1000, // 5 minutes
  maxCacheSize: 100,
  requestTimeoutMs: 30000, // 30 seconds
  enableCaching: false,
  reportCancel: () => {},
  reportSuccess: () => {},
  reportError: () => {},
};
